import { request } from '@/api-client';

type TProps = {
  itemId: string;
  xsrfToken: string;
};

const getFavoriteStatus = ({ itemId, xsrfToken }: TProps): Promise<{ isFavorite: boolean }> =>
  request({
    uri: `/lrp/api/favorite/status?itemId=${encodeURIComponent(itemId)}`,
    method: 'GET',
    credentials: 'same-origin',
    headers: { 'x-mp-xsrf': xsrfToken },
  });

export default getFavoriteStatus;
